import PropTypes from 'prop-types';
import { TableRow, TableCell, Stack, Avatar, Typography, Chip, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProductActions from './ProductActions';

export default function ProductRow({ product, onDelete }) {
    // eslint-disable-next-line no-unused-vars
    const navigate = useNavigate();

    return (
        <TableRow hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar
                        variant="rounded"
                        src={product.thumbnail}
                        alt={product.name}
                        sx={{ width: 48, height: 48, bgcolor: 'grey.100' }}
                    />
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {product.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            ID: {product._id?.slice(-6).toUpperCase()}
                        </Typography>
                    </Box>
                </Stack>
            </TableCell>

            <TableCell>
                <Chip label={product.category?.name || 'Uncategorized'} size="small" variant="outlined" />
            </TableCell>

            <TableCell>
                <Typography variant="body2" sx={{ fontWeight: 700, color: 'primary.main' }}>
                    ₦{product.price.toLocaleString()}
                </Typography>
            </TableCell>

            <TableCell>
                <Chip
                    label={product.stock}
                    color={product.stock > 0 ? 'success' : 'default'}
                    size="small"
                    sx={{ textTransform: 'capitalize', fontWeight: 500 }}
                />
            </TableCell>
            <TableCell>
                <Chip
                    label={product.available ? 'Available' : 'Draft'}
                    color={product.available ? 'success' : 'default'}
                    size="small"
                    sx={{ textTransform: 'capitalize', fontWeight: 500 }}
                />
            </TableCell>

            <TableCell align="right">
                <ProductActions productId={product._id || product.id} productName={product.name} onDelete={onDelete} />
            </TableCell>
        </TableRow>
    );
}

ProductRow.propTypes = {
    product: PropTypes.shape({
        thumbnail: PropTypes.string,
        name: PropTypes.string.isRequired,
        _id: PropTypes.string,
        id: PropTypes.string,
        category: PropTypes.shape({
            name: PropTypes.string
        }),
        price: PropTypes.number.isRequired,
        stock: PropTypes.number,
        available: PropTypes.bool
    }).isRequired,
    onDelete: PropTypes.func.isRequired
};
